<app-manage-device-page
	*ngIf="hasAccess"
	[fromAdminPanel]="true"
></app-manage-device-page>